import githubProfileSummary from "../assets/projects/github-profile-summary.png";
import netflixgpt from "../assets/projects/netflixgpt.png";
import collatzConjectureVisualizer from "../assets/projects/collatz-conjecture-visualizer.png";
import airPollutionVisualizer from "../assets/projects/air-pollution-visualizer.png";
import photosave from "../assets/projects/photosave.png";
import swiggy from "../assets/projects/swiggy.png";
import movieBucket from "../assets/projects/movie-bucket.png";

import lpuLogo from "../assets/education&work/lpu.png";
import geuLogo from "../assets/education&work/geu.png";
import infosysLogo from "../assets/education&work/infosys.png";
import aiotizeLogo from "../assets/education&work/aiotize.png";

const INFO = {
  main: {
    title: "Akash Dandriyal",
    name: "Akash Dandriyal",
    email: "mail@akashdandriyal14@gmail.com",
  },

  socials: {
    github: "https://github.com/Akashdandriyal",
    linkedin: "https://www.linkedin.com/in/akash-dandriyal-2a103a130",
    instagram: "https://instagram.com/akash_dandriyal",
    hackerRank: "https://www.hackerrank.com/akash_d1409",
  },

  homepage: {
    title: "Fullstack Engineer",
    description:
      "I am a JavaScript developer with expertise in Frontend. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow.",
  },
  education: [
    {
      institution: "Lovely Professional University",
      course: "Master of Computer Application",
      duration: "2022-2024",
      logo: lpuLogo,
    },
    {
      institution: "Graphic Era University",
      course: "Bachelor of Science (hons.), Computer Science",
      duration: "2018-2021",
      logo: geuLogo,
    },
  ],
  work: [
    {
      company: "Infosys",
      role: "Senior Systems Associate",
      duration: "2021-Present",
      description: [
        "Developed and maintained dynamic, user-friendly web applications using ReactJS, JavaScript, Tailwind CSS, Angular, HTML and CSS.",
        "Spearheaded efforts to reduce load times by 55% through the implementation of lazy loading, code splitting.",
        "Refactored existing code to improve application modularity, enhancing maintainability by 20%.",
        "Collaborated with backend developers to integrate APIs efficiently, reducing API calls by 30% and improving overall app performance by 50%.",
        "Migrated a CRA application to Vite, leading to a substantial 75% reduction in the application's build size.",
        "Resolved over 100+ bugs and performance issues, reducing user-reported errors by 20% and increasing overall application reliability.",
      ],
      logo: infosysLogo,
    },
    {
      company: "Aiotize",
      role: "Frontend Developer Intern",
      duration: "2020-2020",
      description: [
        "Revamped and built the company’s website from the ground up using ReactJS and Bootstrap.",
        "Improved accessibility features, enhancing user interactivity by 10% and overall experience for disabled users, resulting in a 5% increase of user.",
        "Engineered a comprehensive admin panel that streamlined user data management processes.",
      ],
      logo: aiotizeLogo,
    },
  ],
  projects: [
    {
      title: "Github Profile Summary",
      description:
        "Gives concise overview of a developer's skills, projects, and contributions, providing a snapshot of their expertise and experience.",
      logo: githubProfileSummary,
      linkText: "View Project",
      link: "https://github-profile-summary.vercel.app",
      skills: ["Angular", "Chart.js", "Bootstrap", "Node.js", "Express.js"],
    },
    {
      title: "NetflixGPT",
      description:
        "NetflixGPT is your go-to movie discovery companion, powered by OpenAI GPT-3.",
      logo: netflixgpt,
      linkText: "View Project",
      link: "https://netflix-gptstream.vercel.app",
      skills: [
        "ReactJs",
        "TailwindCSS",
        "Firebase",
        "Node.js",
        "Express.js",
        "OpenAI GPT-3",
      ],
    },
    {
      title: "Air Pollution Visualizer",
      description:
        "It allows users to see pollution data in an easily understandable format. It helps users gain a clearer picture of pollution levels.",
      logo: airPollutionVisualizer,
      linkText: "View Project",
      link: "https://air-pollution-visualizer.vercel.app",
      skills: ["Angular", "Chart.js", "Leaflet", "Bootstrap"],
    },
    {
      title: "Swiggy UI",
      description: "Created a user interface (UI) similar to Swiggy’s website.",
      logo: swiggy,
      linkText: "View Project",
      link: "https://swiggyfood.netlify.app",
      skills: ["ReactJs", "Material UI"],
    },
    {
      title: "Collatz Conjecture Visualizer",
      description:
        "The Collatz conjecture is one of the most famous unsolved problems in mathematics. This webapp visualize the problem in a form of graph.",
      logo: collatzConjectureVisualizer,
      linkText: "View Project",
      link: "https://collatz-conjecture-visualizer-puce.vercel.app",
      skills: ["Angular", "Chart.js", "Material UI"],
    },
    {
      title: "Photosave",
      description:
        "Photosave is a web application that enables users to register their own accounts and upload images for safekeeping.",
      logo: photosave,
      linkText: "View Project",
      link: "https://photosave.onrender.com",
      skills: [
        "Ejs",
        "Bootstrap",
        "Node.js",
        "Express.js",
        "Passport",
        "MongoDB",
        "Cloudinary",
      ],
    },
    {
      title: "Movie Bucket",
      description: "Discover the latest movies with ease using Movie Bucket",
      logo: movieBucket,
      linkText: "View Project",
      link: "https://moviebucket.netlify.app",
      skills: ["ReactJs", "Material UI"],
    },
  ],
  about: {
    title: "Hey, I’m Akash Dandriyal",
    description:
      "As a passionate JavaScript engineer, I thrive on turning ideas into functional and elegant web applications. My journey began when I discovered the magic of code, and I’ve been hooked ever since. Let me share a bit about myself:",
    journey:
      "I embarked on my coding adventure during late nights in college, fueled by caffeine and curiosity. Since then, I’ve honed my skills through countless projects, and collaborative endeavors. Whether it’s building responsive front-end interfaces or optimizing back-end performance, I’m in my element.",
    fact: [
      "When I’m immersed in a coding session, my preferred soundtrack consists of a blend of Hindi and English songs. It keeps me in the zone🎧🎶",
      "When I’m not coding, you’ll find me exploring hiking trails or watching movies.",
    ],
  },
};

export default INFO;
